import * as R from 'ramda'

function objectIncludesKey(object, keyName) {
  return Object.keys(object).includes(keyName)
}

export function findKeyByName(object, keyName) {
  return objectIncludesKey(object, keyName) && object[keyName]
}

export const isFirstStep = R.equals(0)
export const isLastStep = (index: number, steps: any[]) =>
  R.equals(index, R.subtract(R.length(steps), 1))
